export default __webpack_public_path__ + "static/media/Hortons.ad3190ac.png";